import { Icon } from '@eventbrite/eds-icon';
import cx from 'classnames';
import React from 'react';
import { BenefitsItem } from '../types';

type TimelineProps = {
    items: Array<BenefitsItem>;
    activeIdx: number;
    static?: boolean;
};

export const Timeline: React.FC<TimelineProps> = (props) => {
    const renderItems = () => {
        return props.items.map(({ icon: IconType, info, heading }, idx) => (
            <React.Fragment key={idx}>
                <div className="boost-benefits__container">
                    <div className="boost-benefits__container-timeline">
                        <div
                            className={cx([
                                'boost-benefits__timeline--item',
                                {
                                    active:
                                        !props.static && idx <= props.activeIdx,
                                },
                            ])}
                        >
                            <Icon type={IconType} />
                        </div>
                        {idx < props.items.length - 1 ? (
                            <div className="boost-benefits__timeline--line" />
                        ) : null}
                    </div>
                    <div className="boost-benefits__info-container">
                        <div className="eds-text-bm eds-text-weight--heavy">
                            {heading}
                        </div>
                        <div className="eds-text-bm">{info}</div>
                    </div>
                </div>
            </React.Fragment>
        ));
    };

    return <div className="boost-benefits__timeline">{renderItems()}</div>;
};
